import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "../components/ui/input";
import { PageCta } from "../components/site/page-cta";
import { PageHero, Section, SectionHeading } from "../components/site/section";

const ecbCodes = [
    { code: "28-201.1", agency: "DOB", category: "Construction", description: "Failure to comply with a provision of the New York City Construction Codes." },
    { code: "28-202.1", agency: "DOB", category: "Work without a permit", description: "Work performed without the required permit or after a permit has expired." },
    { code: "28-203.1", agency: "DOB", category: "Stop work order", description: "Failure to comply with a stop work order issued by the Department of Buildings." },
    { code: "27-2005", agency: "HPD", category: "Owner duties", description: "Owner responsibility to keep a dwelling and its equipment in good repair." },
    { code: "15-216", agency: "FDNY", category: "Fire safety", description: "Noncompliance with a Fire Department order or fire-safety requirement." },
];
function EcbCodeSearch() {
    const [query, setQuery] = useState("");
    const normalizedQuery = query.trim().toLowerCase();
    const results = useMemo(() => ecbCodes.filter((item) => !normalizedQuery || Object.values(item).some((value) => value.toLowerCase().includes(normalizedQuery))), [normalizedQuery]);
    return (<>
      <PageHero title="ECB Code Search" description="Look up common ECB and OATH violation codes by code, agency, category, or keyword."/>
      <Section>
        <SectionHeading title="Find a violation code" description="Search the reference below for a plain-language summary of the cited condition."/>
        <div className="relative mt-10 max-w-2xl">
          <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground"/>
          <Input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search by code, agency, or keyword" aria-label="Search ECB codes" className="h-12 pl-12"/>
        </div>
        <div className="mt-8 max-w-4xl divide-y divide-border border-y border-border">
          {results.map((item) => (<article key={item.code} className="grid gap-3 py-6 md:grid-cols-[9rem_1fr]">
              <div>
                <p className="font-mono text-base font-semibold text-foreground">{item.code}</p>
                <p className="mt-1 text-xs font-semibold uppercase text-muted-foreground">{item.agency}</p>
              </div>
              <div>
                <h2 className="font-semibold text-foreground">{item.category}</h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.description}</p>
              </div>
            </article>))}
          {results.length === 0 && (<p className="py-10 text-sm text-muted-foreground">No matching codes found. Try a broader keyword or agency name.</p>)}
        </div>
        <p className="mt-6 max-w-3xl text-xs leading-relaxed text-muted-foreground">
          This reference is provided for general information. Confirm the full charge and current requirements on the official summons or with the issuing agency.
        </p>
      </Section>
      <PageCta />
    </>);
}

export default EcbCodeSearch;
